import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Icon } from '../common/Icons';

export default function Topbar({
  onToggleSidebar,
  onOpenSearch,
  onNewNote,
}) {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Global ⌘K shortcut to open search modal
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        onOpenSearch();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onOpenSearch]);

  const initials = (user?.firstName?.[0] || user?.username?.[0] || 'U').toUpperCase();

  return (
    <header className="topbar">
      {/* Top-Left: Sandwich / Hamburger Button + Brand */}
      <div className="topbar-left">
        <button
          type="button"
          className="topbar-sandwich-btn"
          onClick={onToggleSidebar}
          aria-label="Toggle navigation sidebar"
          title="Toggle Navigation Menu"
        >
          <Icon name="menu" size={22} />
        </button>

        <div
          className="topbar-brand"
          onClick={() => navigate('/')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter') navigate('/'); }}
          title="Go to Home"
          style={{ cursor: 'pointer' }}
        >
          <span className="logo-text">Memora</span>
        </div>
      </div>

      {/* Header Center: Search Bar Trigger (Opens full blurred search interface) */}
      <div className="topbar-center">
        <div
          className="topbar-search-input-pill"
          onClick={onOpenSearch}
          role="button"
          tabIndex={0}
          title="Search notes and categories (⌘K)"
        >
          <Icon name="search" size={16} className="search-pill-icon" />
          <span className="search-pill-placeholder">Search notes, tags, or categories...</span>
          <span className="search-pill-kbd">⌘K</span>
        </div>
      </div>

      {/* Beside Search Bar: New Note Plus Icon and Profile Icon */}
      <div className="topbar-right">
        {/* Modern Plus Icon Button */}
        <button
          type="button"
          className="topbar-plus-btn"
          onClick={onNewNote}
          aria-label="Create New Note or Category"
          title="Create New Note or Category"
        >
          <Icon name="plus" size={18} />
        </button>

        {/* Profile Icon / Your Account Trigger */}
        <div className="topbar-profile-wrapper">
          <button
            type="button"
            className="topbar-profile-btn"
            onClick={() => navigate('/account')}
            aria-label="Your Account"
            title="Your Account"
          >
            <div className="topbar-profile-avatar">
              {initials}
            </div>
          </button>
        </div>
      </div>
    </header>
  );
}
